// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"5d54a38b","88":"528558a2","141":"db8e83a0","495":"e1e6dd6c","558":"234e92bc","584":"b2a7451c","759":"4e1ba3c0","787":"28cb0dcd","979":"92487451"}[chunkId] + ".chunk.js";
};